<template>
  <div class="tm-liga-dropdown__panel">
    <button
      v-for="liga in ligenSortiert"
      :key="liga.id"
      type="button"
      class="tm-liga-dropdown__option"
      :class="{ 'tm-liga-dropdown__option--aktiv': liga.id === modelValue }"
      @click="$emit('select', liga.id)"
    >
      <img v-if="liga.flaggeBild" :src="liga.flaggeBild" class="tm-liga-dropdown__flagge" alt="" />
      <span v-else class="tm-liga-dropdown__flagge-platzhalter"></span>
      <span class="tm-liga-dropdown__label">{{ liga.label }}</span>
      <button
        v-if="liga.id !== 'alle'"
        type="button"
        class="tm-liga-dropdown__favorit-btn"
        :class="{ 'tm-liga-dropdown__favorit-btn--aktiv': istLigaFavorit(liga.id) }"
        :aria-label="istLigaFavorit(liga.id) ? 'Aus Favoriten entfernen' : 'Als Favorit merken'"
        @click.stop="toggleLigaFavorit(liga.id)"
      >{{ istLigaFavorit(liga.id) ? '★' : '☆' }}</button>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useLigaFavoriten } from '../composables/useLigaFavoriten.js'

const props = defineProps({
  ligen: { type: Array, required: true },
  modelValue: { type: String, required: true }
})
defineEmits(['select'])

const { istLigaFavorit, toggleLigaFavorit } = useLigaFavoriten()

// "Alle" bleibt immer ganz oben, danach Favoriten (in ihrer ursprünglichen Reihenfolge),
// danach der Rest (ebenfalls in ursprünglicher Reihenfolge) - kein zusätzliches alphabetisches
// Umsortieren, um die bestehende (z.B. nach Popularität gewichtete) Backend-Reihenfolge
// innerhalb der beiden Gruppen nicht zu verlieren.
const ligenSortiert = computed(() => {
  const alle = props.ligen.filter(l => l.id === 'alle')
  const rest = props.ligen.filter(l => l.id !== 'alle')
  const favoriten = rest.filter(l => istLigaFavorit(l.id))
  const nichtFavoriten = rest.filter(l => !istLigaFavorit(l.id))
  return [...alle, ...favoriten, ...nichtFavoriten]
})
</script>